export const ERR_API_CALL_TRANSCRIPTS_NOT_READY =
  'ERR_API_CALL_TRANSCRIPTS_NOT_READY';

export const CANCEL_WRAPUP_FAILED = 'CANCEL_WRAPUP_FAILED';
export const UPDATE_STATUS_FAILED = 'UPDATE_STATUS_FAILED';
